import React from 'react';
import SourceComponent from './NewControls/SourceComponent';
import { getControlStyle, renderColumnType, shortenandHoverString } from '../../../../../Components/helper';
import { useCustomModuleState } from '../../Context/index';
import CommonAction from './CommonAction';

function SourceControl({
  label,
  index,
  gridIndex,
  onChange,
  duplicatingItem,
  pageIndex,
  fromForm,
  showDelete,
  handleSupplierPermission,
  supplierVisible,
  editingInput,
  deleteItem,
  isLabel,
  setIsLabel,
  setOnElement,
  onElement,
  otherConfiguration,
  isEditLabel,
  setIsEditLabel,
  setDroppedIndex,
  relation,
  boldLabel,
  handleStaticGrid,
  isStatic,
}) {
  const { customModuleState } = useCustomModuleState();
  const handleDuplicateItem = () => {
    duplicatingItem(gridIndex, pageIndex);
    setOnElement(false);
  };
  const combinedStyles = getControlStyle(otherConfiguration);
  const showEdit = customModuleState?.modalEdit ? isEditLabel : isLabel;
  return showEdit ? (
    <div className={`${label ? 'label-added' : ''} h-100`}>
      <div style={combinedStyles} className="custom-source-column">
        {label && <label className={`fs-custom-module asterisk-req ${fromForm && 'd-flex'} ${boldLabel && 'font-weight-bold'}`}>{label}</label>}
        <p className="fs-custom-module mb-0">{shortenandHoverString(renderColumnType(relation), 20)}</p>
      </div>
      {fromForm && onElement && (
        <CommonAction
          editingInput={editingInput}
          gridIndex={gridIndex}
          pageIndex={pageIndex}
          showDelete={showDelete}
          deleteItem={deleteItem}
          handleDuplicateItem={handleDuplicateItem}
          supplierVisible={supplierVisible}
          handleSupplierPermission={handleSupplierPermission}
          handleStaticGrid={handleStaticGrid}
          isStatic={isStatic}
        />
      )}
    </div>
  ) : (
    <SourceComponent
      gridIndex={gridIndex}
      pageIndex={pageIndex}
      index={index}
      setIsLabel={setIsLabel}
      deleteItem={deleteItem}
      onChange={onChange}
      setIsEditLabel={setIsEditLabel}
      showEdit={showEdit}
      setDroppedIndex={setDroppedIndex}
    />
  );
}

export default SourceControl;
